// Stub for react-native-reanimated on web
// gesture-handler imports it optionally for animated gestures
import { View } from 'react-native';

export const useSharedValue = (init) => ({ value: init });
export const useAnimatedStyle = () => ({});
export const withTiming = (v) => v;
export const withSpring = (v) => v;
export const withDecay = (v) => v;
export const runOnJS = (fn) => fn;
export const runOnUI = (fn) => fn;
export const createAnimatedComponent = (Component) => Component;
export default { createAnimatedComponent };
